import React, { useEffect, useState } from 'react';

const LoadingProgressBar = ({ setVendorsTimesUp }) => {
  const [progress, setProgress] = useState(0);
  const duration = 120000; // 2 minutes
  const intervalTime = 100;

  useEffect(() => {
    let startTime = localStorage.getItem('progressStartTime');
    let startTimestamp = startTime ? parseInt(startTime, 10) : Date.now();

    if (!startTime) {
      localStorage.setItem('progressStartTime', startTimestamp.toString());
    }

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTimestamp;
      const calculatedProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(calculatedProgress);
    }, intervalTime);

    return () => clearInterval(interval);
  }, []);

  // Trigger only when actual visible progress reaches 100
  useEffect(() => {
    if (progress >= 100) {
      setVendorsTimesUp(true);
      localStorage.removeItem('progressStartTime');
    }
  }, [progress, setVendorsTimesUp]);

  return (
    <div
      style={{
        width: '100%',
        height: '0.5rem',
        backgroundColor: '#f1f1f1',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${progress}%`,
          height: '100%',
          backgroundColor: '#21A6E9',
          transition: 'width 0.1s linear',
        }}
      />
    </div>
  );
};

export default LoadingProgressBar;
